<template>
  <div align="center">
    <v-carousel
      v-if="screenSize != 'mobile'"
      height="550"
      show-arrows="hover"
      cycle
      hide-delimiter-background
    >
      <v-carousel-item
        v-for="(item, i) in banners"
        :key="i"
        :src="item.foto"
        cover
      ></v-carousel-item>
      <v-carousel-item
        v-if="LoadingCarrucel"
        src="https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/BannersCarrusel%2F1.png?alt=media&token=d1d900f2-75bc-4fa0-93cc-4694786bc911"
        cover
      >
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      v-else
      height="auto"
      show-arrows="hover"
      cycle
      hide-delimiter-background
    >
      <v-carousel-item
        v-for="(item, i) in banners"
        :key="i"
        :src="item.foto"
        cover
      >
      </v-carousel-item>
    </v-carousel>
  </div>

  <swipper-component />
  <v-container style="padding-top: 4rem; padding-bottom: 4rem">
    <p
      align="center"
      style="
        color: #1866c0;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 800;
        font-size: 2rem;
      "
    >
      PRINCIPALES SERVICIOS
    </p>
    <divider-component />
    <v-spacer style="height: 50px"></v-spacer>
    <v-row>
      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="12"
        xs="12"
        v-for="(items, i) in ItemsCard"
        :key="i"
      >
        <card-component
          :title="items.title"
          :subtitle="items.subtitle"
          :description="items.description"
          :foto="items.foto"
          :ExtraInfo="items.ExtraInfo"
          :Ruta="items.ruta"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CarruselComponent from '@/components/CarruselComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SwipperComponent from '@/components/SwipperComponent.vue';
import ApiCarrusel from '@/Api/CarruselApi';
import DividerComponent from '@/components/DividerComponent.vue';

export default {
  name: 'HomeView',
  mounted() {
    this.GetAllImages();
    this.updateScreenSize(); // Actualiza en la carga inicial
    window.addEventListener('resize', this.updateScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenSize); // Limpia el listener al destruir el componente
  },
  data() {
    return {
      screenSize: '',
      ItemsCard: [
        {
          id: 1,
          title: 'Venta de Herramientas para Construcción',
          subtitle: 'VENTA',
          foto: 'https://th.bing.com/th/id/R.29d2a4950da6718b2e30207d7b4b787b?rik=A1d1dZTw0o59ZA&riu=http%3a%2f%2fwww.materialesplutarco.com%2fwp-content%2fuploads%2f2019%2f06%2fherramientas-truper-precio.png&ehk=bYQKct2Le62SemT2XcXDDHETbwcQtrO0jfCdXddRyYQ%3d&risl=&pid=ImgRaw&r=0',
          description:
            '¡Equipa tu proyecto con lo mejor! En nuestra empresa, encontrarás una amplia gama de herramientas para construcción, desde básicas hasta especializadas. Calidad y durabilidad garantizadas. ¡Visítanos y construye con confianza!"',
          ExtraInfo: false,
          ruta: 'productos',
        },
        {
          id: 2,
          title: 'Venta de Vibrocomprimidos',
          subtitle: 'VENTA',
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2FCaptura%20de%20pantalla%202024-01-11%20083618.png?alt=media&token=f1964673-37a6-45de-8968-7e00cb27a446',
          description:
            '¿Buscas materiales de alta resistencia para tu obra? Ofrecemos vibrocomprimidos de excelente calidad, ideales para pavimentación y construcción. Durabilidad y eficiencia a tu alcance. ¡Consulta nuestro catálogo y elige lo mejor para tu construcción!',
          ExtraInfo: false,
          ruta: 'bloquera',
        },
        {
          id: 3,
          title: 'Gestión de Trámites INFONAVIT',
          subtitle: 'SERVICIO',
          foto: 'https://www.heraldobinario.com.mx/u/fotografias/m/2021/12/8/f1280x720-20084_151759_5050.jpg',
          description:
            '¿Necesitas ayuda con tus trámites de INFONAVIT? Nuestro equipo de expertos te guía paso a paso en el proceso, asegurando un manejo eficiente y rápido. Confía en nosotros para agilizar tus trámites de vivienda. ¡Contáctanos ya!',
          ExtraInfo: true,
          ruta: '',
        },
      ],
      banners: [],
      LoadingCarrucel: true,
    };
  },
  components: {
    CardComponent,
    CarruselComponent,
    SwipperComponent,
    DividerComponent,
  },
  methods: {
    async GetAllImages() {
      await ApiCarrusel.getAll()
        .then((response) => {
          this.banners = response.data;
          this.LoadingCarrucel = false;
        })
        .catch((error) => {
         
        });
    },
    updateScreenSize() {
      // Actualiza screenSize usando la propiedad computada
      this.screenSize = this.calculateScreenSize;
    },
  },
  computed: {
    calculateScreenSize() {
      const width = window.innerWidth;

      if (width < 768) {
        return 'mobile';
      } else if (width >= 768 && width < 1024) {
        return 'tablet';
      } else {
        return 'desktop';
      }
    },
  },
};
</script>

<style scoped>
.carrusel-container {
  overflow: auto;
  white-space: nowrap;
}

.carrusel .card {
  display: inline-block;
  width: 200px; /* Ancho de la tarjeta */
  height: 300px; /* Altura de la tarjeta */
  margin-right: 16px; /* Espaciado entre tarjetas */
  background-color: #f0f0f0; /* Color de fondo de la tarjeta */
  border: 1px solid #ddd; /* Borde de la tarjeta */
  border-radius: 8px; /* Bordes redondeados */
  /* Alineación del contenido de la tarjeta */
  text-align: center;
  vertical-align: top;
  line-height: 300px; /* Centra verticalmente el texto dentro de la tarjeta */
}

/* Estilización opcional para mejorar la apariencia */
.carrusel-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.carrusel-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.carrusel-container::-webkit-scrollbar-track {
  background: #efefef;
  border-radius: 10px;
}
</style>
